
/**
 * 응답 데이터
 * @nullable
 */
export type PostApiV1RefundsRequest200AllOfData = { [key: string]: unknown } | null;
